import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LayersIcon, BarChart3Icon, BrainCircuitIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-white overflow-hidden" data-id="element-170">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        {/* Solution Header */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-172">
          <span className="text-[#1B3A5C] font-bold tracking-wider uppercase text-sm" data-id="element-173">
            EL ECOSISTEMA CLÍNICO
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2 mb-4" data-id="element-174">
            MEGA PACK DE INTERVENCIÓN FONOAUDIOLÓGICA INFANTIL™
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8" data-id="element-175">
            No son fichas sueltas. No es un pack de actividades genéricas. Es un
            sistema clínico completo organizado por nivel de edad, con criterios
            de avance reales.
          </p>
        </motion.div>

        {/* System Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-176">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#EDF2F7] p-8 rounded-xl border border-blue-100 hover:shadow-lg transition-shadow" data-id="element-177">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm mb-6" data-id="element-178">
              <LayersIcon className="w-6 h-6 text-[#C9A84C]" data-id="element-179" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-180">
              📘 SISTEMA POR NIVELES
            </h3>
            <ul className="space-y-3" data-id="element-181">
              {['3 niveles por tomo (3-5, 6-8, 9-12 años)', 'Progresión clínica clara', 'Criterios de avance objetivos', 'Materiales por edad'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-182">
                  <CheckIcon className="w-4 h-4 text-[#1B3A5C] mt-0.5 flex-shrink-0" data-id="element-183" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#EDF2F7] p-8 rounded-xl border border-blue-100 hover:shadow-lg transition-shadow" data-id="element-184">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm mb-6" data-id="element-185">
              <BarChart3Icon className="w-6 h-6 text-[#C9A84C]" data-id="element-186" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-187">
              📊 EVIDENCIA QUE SE VE
            </h3>
            <p className="text-sm text-gray-600 mb-4" data-id="element-188">
              Monitor de Evidencia Visual™ integrado.
            </p>
            <ul className="space-y-3" data-id="element-189">
              {['Gráficos de progreso', 'Semáforos de avance', 'Reportes visuales', 'Mostrale a los padres en 30 segundos que su hijo está mejorando'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-190">
                  <CheckIcon className="w-4 h-4 text-[#1B3A5C] mt-0.5 flex-shrink-0" data-id="element-191" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-[#EDF2F7] p-8 rounded-xl border border-blue-100 hover:shadow-lg transition-shadow" data-id="element-192">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm mb-6" data-id="element-193">
              <BrainCircuitIcon className="w-6 h-6 text-[#C9A84C]" data-id="element-194" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-195">
              🧠 SESIONES ESPECÍFICAS POR PERFIL
            </h3>
            <ul className="space-y-3" data-id="element-196">
              {['24 sesiones específicas para TEA', '24 sesiones específicas para TDAH', '24 sesiones específicas para ansiedad', 'No modificás nada, solo aplicás', 'Protocolo de crisis incluido'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-197">
                  <CheckIcon className="w-4 h-4 text-[#1B3A5C] mt-0.5 flex-shrink-0" data-id="element-198" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* What Changes Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#1B3A5C] rounded-2xl p-8 md:p-12 text-white" data-id="element-199">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-10" data-id="element-200">
            ¿QUÉ CAMBIA CUANDO TRABAJÁS ASÍ?
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-201">
            <div className="relative" data-id="element-202">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#C9A84C] rounded-full" data-id="element-203" />
              <div className="pl-6" data-id="element-204">
                <h4 className="text-xl font-bold mb-4 text-[#C9A84C]" data-id="element-205">
                  En sesión:
                </h4>
                <ul className="space-y-3" data-id="element-206">
                  {['Entrás sabiendo qué hacer', 'Tenés criterios de avance claros', 'Adaptaciones integradas', 'Cero improvisación'].map((item, i) => <li key={i} className="flex items-center gap-2 text-lg" data-id="element-207">
                      <CheckIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-208" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="relative" data-id="element-209">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#C9A84C] rounded-full" data-id="element-210" />
              <div className="pl-6" data-id="element-211">
                <h4 className="text-xl font-bold mb-4 text-[#C9A84C]" data-id="element-212">
                  Fuera de sesión:
                </h4>
                <ul className="space-y-3" data-id="element-213">
                  {['Cero planificación a medianoche', 'Informes en minutos', 'Padres ven el progreso', 'Cabeza descansada'].map((item, i) => <li key={i} className="flex items-center gap-2 text-lg" data-id="element-214">
                      <CheckIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-215" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}